import React from "react";

const RedirectUrlContext = React.createContext({
  redirectUrl: "",
  setRedirectUrl: () => {},
});

export default RedirectUrlContext;
